module.exports = __webpack_public_path__ + "img/hero_diagonal.96a94b94.png";